import { HTMLAttributes } from 'react';
import { useTranslate } from '@tolgee/react';
import { formatNumber } from 'utils/numberFormat';
import { DetailItem, Amount, priceRender } from './TradeDetailPaymentLazada';

export interface TradeDetailPaymentKwaiProps extends HTMLAttributes<HTMLElement> {
  trade: Conversation.Trade.Vo;
}

export const TradeDetailPaymentKwai = (props: TradeDetailPaymentKwaiProps) => {
  const { trade, className, ...otherProps } = props;
  const { unit, buyerPayment } = trade;

  const { t } = useTranslate();

  const total = priceRender(buyerPayment?.buyerTotalAmount, (val) => {
    return (
      <DetailItem
        key="total"
        style={
          className === 'tradeDetail'
            ? { border: '1px solid #F0F2F5', padding: '0 16px', lineHeight: '40px' }
            : {}
        }
      >
        <span style={className === 'tradeDetail' ? { fontWeight: 'bold' } : {}}>
          {t('trade.买家实付金额')}
        </span>
        {className !== 'tradeDetail' ? (
          <Amount isfold>
            <div>{`${unit} ${formatNumber(val, '0,0.00')}`}</div>
          </Amount>
        ) : null}
      </DetailItem>
    );
  });

  return total ? <div {...otherProps}>{total}</div> : null;
};
